export default __webpack_public_path__ + "static/media/closeIcon.1d8d2500.svg";